import { ExternalLink, Globe } from "lucide-react";
import React, { useMemo } from "react";
import type { EvidenceEvent, WebSourceRef } from "../../../types/evidence";
import "./EvidenceCards.css";

interface WebSourceCardProps {
	event: EvidenceEvent;
}

interface DecoratedWebRef {
	key: string;
	ref: WebSourceRef;
	displayLabel: string;
}

const decorateWebRefs = (event: EvidenceEvent): DecoratedWebRef[] =>
	event.source_refs
		.filter((r): r is WebSourceRef => r.kind === "web")
		.map((ref, index) => ({
			key: `${ref.url}-${index}`,
			ref,
			displayLabel: ref.title ?? ref.url,
		}));

const WebSourceCard: React.FC<WebSourceCardProps> = ({ event }) => {
	const decorated = useMemo(() => decorateWebRefs(event), [event]);

	return (
		<article className="evidence-card evidence-card--web">
			<ul className="evidence-card-list evidence-card-list--web">
				{decorated.map(({ key, ref, displayLabel }) => (
					<li key={key} className="evidence-card-row evidence-card-row--web">
						<a
							href={ref.url}
							target="_blank"
							rel="noopener noreferrer"
							className="evidence-card-web-link evidence-card-web-link--neutral"
						>
							<Globe
								className="evidence-card-web-link-icon evidence-card-web-link-icon--leading"
								aria-hidden
							/>
							<span className="evidence-card-web-link-label">
								{displayLabel}
							</span>
							<ExternalLink
								className="evidence-card-web-link-icon evidence-card-web-link-icon--trailing"
								aria-hidden
							/>
						</a>
					</li>
				))}
			</ul>
		</article>
	);
};

export default React.memo(WebSourceCard);
